import { useEffect } from "react";

export default function ChatWidget() {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://chatzy-kb-store.s3.amazonaws.com/icons/5ab07987-b5db-477c-82ff-1287e0883acb";
    link.dataset.chatzy = "1";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src = "https://chatzy-kb-store.s3.amazonaws.com/icons/56706cc4-b3ba-4eba-9610-f2fb07008a5c";
    script.id = "c88e6c9f-1632-44d3-8b92-5e0344b801d8";
    script.className = "chatzy_widget_script";
    script.defer = true;
    script.dataset.chatzy = "1";
    document.body.appendChild(script);

    return () => {
      link.remove();
      script.remove();
    };
  }, []);
  return null;
}
